import React from "react";
import "../../styles/PaymentHero.css";

const PaymentHero = ({ payment }) => {

    if (!payment) return null;

    return (
        <div className="payment-hero">

            <div className="payment-hero-left">

                <h2>
                    {payment.paymentNumber}
                </h2>

                <p>
                    Order : {payment.orderNumber}
                </p>

                <p>
                    Transaction :
                    {" "}
                    {payment.payment?.transactionId || "-"}
                </p>

            </div>

            <div className="payment-hero-center">

                <h3>
                    ₹{payment.pricing?.grandTotal}
                </h3>

                <span className={`payment-status ${payment.payment?.status?.toLowerCase()}`}>
                    {payment.payment?.status}
                </span>

            </div>

            <div className="payment-hero-right">

                <p>
                    <strong>Method</strong>
                </p>

                <p>{payment.payment?.method}</p>

                <br />

                <p>
                    <strong>Gateway</strong>
                </p>

                <p>{payment.payment?.gateway}</p>

            </div>

        </div>
    );

};

export default PaymentHero;